import { Component, Input, OnChanges } from '@angular/core';
import { ChatMessage, SupplyDropEndContent, SupplyDropStartContent } from '@models/chat-message.interface';
import { CurrencyComponent } from '@shared/currency/currency.component';
import { IconComponent } from '@shared/icon/icon.component';

@Component({
  selector: 'app-chat-supply-drop',
  templateUrl: './chat-supply-drop.component.html',
  styleUrls: ['./chat-supply-drop.component.scss'],
  imports: [IconComponent, CurrencyComponent],
})
export class ChatSupplyDropComponent implements OnChanges {
  @Input() event: ChatMessage;

  startContent: SupplyDropStartContent | null = null;
  endContent: SupplyDropEndContent | null = null;

  ngOnChanges(): void {
    if (!this.event) {
      return;
    }

    this.startContent = this.event.type === 'supplyDropStart' ? (this.event.content as SupplyDropStartContent) : null;
    this.endContent = this.event.type === 'supplyDropEnd' ? (this.event.content as SupplyDropEndContent) : null;
  }
}
